<template>
  <v-app>
    <v-dialog v-model="dialog" max-width="800">
      <v-card>
        <v-card-title>
          {{ `${category.id ? 'Update' : 'Add'}` }} Category
        </v-card-title>
        <v-card-text>
          <div class="row">
            <div class="col-12 form-group">
              <v-text-field outlined dense label="Title" v-model="category.title"></v-text-field>
              <span class="text-danger" v-if="$v.category.title.$error">Title is required.</span>
            </div>


            <div class="col-12 form-group">
              <b-form-checkbox v-model="category.is_active" name="check-button" class switch>Status</b-form-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-right">
              <v-btn
                  class="btn  btn-light-primary font-weight-bold px-9 py-4 my-3 font-size-3 mx-4"
                  depressed
                  @click="resetForm"
              >Cancel
              </v-btn>
              <v-btn
                  class="text-primary btn btn-primary btn   font-weight-bold px-9 py-4 my-3 font-size-3 mx-4"
                  depressed
                  @click="createOrUpdate"
                  :loading="isBusy"
              >Save
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>

</template>
<script>
import {required} from "vuelidate/lib/validators";

import QuestionBankCategoryService from "@/core/services/quiz/question-bank/category/QuestionBankCategoryService";

const categoryService = new QuestionBankCategoryService();

export default {
  props: ['dialog'],
  validations: {
    category: {
      title: {required},
    }
  },
  data() {
    return {
      edit: false,
      isBusy: false,
      category: {
        title: null,
        is_active: true,
      }
    };
  },
  mounted() {
  },
  methods: {
    showModal(categoryId = null) {
      if (categoryId) {
        this.edit = true;
        this.getCategory(categoryId);
      }
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["my-modal"].toggle("#toggle-btn");
    },
    getCategory(id) {
      categoryService.show(id).then(response => {
        this.category = response.data.category;
      });
    },
    createOrUpdate() {
      this.$v.category.$touch();
      if (this.$v.category.$error) {
        setTimeout(() => {
          this.$v.category.$reset();
        }, 3000);
      } else {
        if (this.category.id) {
          this.updateType();
        } else {
          this.createType();
        }
      }
    },
    createType() {
      categoryService.store(this.category).then(response => {
        this.resetForm()
      });
    },
    updateType() {
      categoryService.update(this.category.id, this.category).then(response => {
        this.resetForm()
      });
    },
    resetForm() {
      this.category = {
        title: null,
        is_active: null,
      };
      this.$v.category.$reset();
      this.$emit("refresh_list");

    },
    setType(category) {
      this.category = category
    },
    onSuccess(){
      this.cancelQuestionDialog()
    }
  }
};
</script>